import React from "react";
import {
    Card,
    CardContent,
    Box,
    Typography,
    Avatar,
    IconButton,
    Divider,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";

const DoctorBanner = ({ data }) => {

    const navigate = useNavigate();

    return (
        <Card
            variant="outlined"
            onClick={()=> navigate(`/profile?cat=doctor&id=${data?.id}`)}
            sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" }, // Responsive layout
                marginTop: 2,
                alignItems: "center",
                borderRadius: 2,
                borderColor: "#b5e0bc",
                p: 1,
                bgcolor: "#f9fdf9",
                transition: "box-shadow 0.3s ease-in-out",
                cursor:"pointer",
                "&:hover": {
                    boxShadow: 4, // Elevation on hover
                },
            }}
        >
            {/* Section 1: Icon + Specialty */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    bgcolor: "#e7f5ea",
                    p: 2,
                    borderRadius: 2,
                    minWidth: 160,
                    width: { xs: "100%", md: "auto" },
                }}
            >
                <Avatar
                    src={data?.profilePicture} // Replace with actual logo
                    alt="Logo"
                    sx={{ width: 48, height: 48 }}
                />
                <Typography variant="body2" color="text.secondary">
                    {data?.department}
                </Typography>
            </Box>

            {/* Section 2: Hospital Info */}
            <CardContent
                sx={{
                    flex: 1,
                    py: 1,
                    width: "100%",
                    textAlign: { xs: "center", md: "left" },
                }}
            >
                <Typography variant="subtitle1" fontWeight="bold">
                    {data?.healthCareProvider?.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {data?.healthCareProvider?.address || data?.location || ""}
                </Typography>
            </CardContent>

            {/* Divider for large screens only */}
            <Divider
                orientation="vertical"
                flexItem
                sx={{ display: { xs: "none", md: "block" } }}
            />

            {/* Section 3: Doctor Info + Arrow */}
            <Box
                sx={{
                    px: 2,
                    py: { xs: 2, md: 0 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    minWidth: 240,
                    width: { xs: "100%", md: "auto" },
                }}
            >
                <Box textAlign={{ xs: "center", md: "left" }}>
                    <Typography variant="subtitle2" fontWeight="bold">
                        {`Dr. ${data?.firstName} ${data?.lastName}`}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {data?.department}
                    </Typography>
                </Box>
                <IconButton
                    sx={{
                        transition: "transform 0.2s ease-in-out",
                        "&:hover": { transform: "translateX(2px)" },
                    }}
                >
                    <ArrowForwardIosIcon fontSize="small" sx={{ color: "#7edc96" }} />
                </IconButton>
            </Box>
        </Card>
    );
};

export default DoctorBanner;
